import React from 'react';
import { AdminGuard } from '../../guards/RolesGuard';

interface INavigation {
    search?: string
}

const Navigation = ({
    search
}: INavigation) => {


    return (
        <div className='flex flex-col min-h-[100%] justify-between'>

            <>
                {AdminGuard() &&
                    <div className=''>
                        {/* <p className='mb-3 text-[#8a8a8e] text-[13px]'>History</p> */}
                        <p className='mb-3 text-[#8a8a8e] dark:text-primary-darkMode text-[13px]'>AI Agents</p>
                        <div className='bg-[#F5F5F5] dark:bg-black rounded-lg my-3 flex flex-row items-center p-2 cursor-pointer hover:opacity-80'>
                            <img src={'/assets/agents/rebecca-agent.svg'} className={'object-contain w-[25px] !rounded-lg mr-2'} />
                            <p className='dark:text-primary-darkMode'>Rebecca</p>
                            <p className='text-primary-light truncate ml-2'>AI Guest Experience</p>
                        </div>
                    </div>
                }
                <div className='mb-1 pt-2'>

                </div>
            </>

        </div>
    );
};

export default Navigation;